module.exports = __webpack_public_path__ + "img/analysis.55bbae42.svg";